"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHeartColor = exports.loaderHeartColors = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Lottie_1 = __importDefault(require("../Lottie"));
const classnames_1 = __importDefault(require("classnames"));
// @ts-ignore
const sass_variables_scss_1 = __importDefault(require("../../styles/sass-variables.scss"));
const loaderHeart_module_scss_1 = __importDefault(require("./loaderHeart.module.scss"));
exports.loaderHeartColors = ['RED', 'PINK', 'BLACK'];
exports.defaultHeartColor = 'RED';
const LoaderHeart = ({ color = 'RED', defaultMobileSize = 120, defaultDesktopSize = 200, speed = 0.7, fullScreen = false, }) => {
    const mediaQueryList = window.matchMedia(`(min-width: ${sass_variables_scss_1.default.desktopSmallWidth})`);
    const [size, setSize] = (0, react_1.useState)(() => {
        return mediaQueryList.matches ? defaultDesktopSize : defaultMobileSize;
    });
    const onMediaChange = (e) => {
        if (e.matches) {
            setSize(defaultDesktopSize);
        }
        else {
            setSize(defaultMobileSize);
        }
    };
    (0, react_1.useEffect)(() => {
        mediaQueryList.addListener(onMediaChange);
        return () => {
            mediaQueryList.removeListener(onMediaChange);
        };
    }, []);
    const defaultOptions = (0, react_1.useMemo)(() => ({
        loop: true,
        autoplay: true,
        animationData: require(`../../assets/animations/loader-heart/loader-heart--${color.toLowerCase()}.json`),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }), [color]);
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(fullScreen && loaderHeart_module_scss_1.default.fullScreen, loaderHeart_module_scss_1.default[`color_${color.toLowerCase()}`]), children: (0, jsx_runtime_1.jsx)(Lottie_1.default, { options: defaultOptions, speed: speed, width: size, height: size }) }));
};
exports.default = LoaderHeart;
